import React, { useEffect, useState } from 'react';
import { BetDetails } from '../../../models/MyBetModel.tsx';
import { getUserBets } from '../../../services/player/BetService.tsx';
import PendingBetComponent from '../pendig/PendingBetComponent.tsx';
import { useParams } from 'react-router-dom';
import { Timestamp } from 'firebase/firestore';
import { useUser } from '../../../context/UserContext.tsx';

function DayCalendarComponent() {
    
    const { user } = useUser();
    const [userBet, setUserBet] = useState<BetDetails[]>([]);
    const { date } = useParams();
    const selectedDate = date ? new Date(date) : new Date();

    const loadBets = async () => {
        const startDate = new Date(selectedDate);
        const endDate = new Date(selectedDate);
        endDate.setDate(endDate.getDate() + 1);
        const usersBets = await getUserBets(user?.userName ?? '', Timestamp.fromDate(startDate), Timestamp.fromDate(endDate));
        setUserBet(usersBets);
    }

    useEffect(() => {
        loadBets();
    }, [date]);

    const totalPendingBets = userBet.reduce((total, bet) => total + (bet.reward || 0), 0);

    return (
        <>
            <div className="flex-container">
                <div>
                    <span className="rdp-caption_label">{selectedDate.toDateString()}</span>
                </div>
                <div className='title-total'>
                    <span className="title-container teko">TOTAL: <span className="additional-text teko">+ {totalPendingBets}</span>
                    </span>
                </div>
            </div>
            <div className='header-pending'>
                <div className='description-container'>
                    <span className='table-letters'>DESCRIPTION</span>
                </div>
                <div className='risk-container'>
                    <span className='table-letters'>RISK</span>
                </div>
                <div className='reward-container'>
                    <span className='table-letters'>REWARD</span>
                </div>
            </div>
            {userBet.length > 0 && (
                <div className="pending-list">
                    {userBet.map((bets, key) => (
                        <div key={key} className="pending-body">
                            <PendingBetComponent {...bets} />
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}
export default DayCalendarComponent;
